import { TableField, defaultDateFormatter } from "@/types/table-field";

const idAviso: TableField = {
  key: "Id",
  label: "ID",
  tdClass: ["align-middle", "naoQuebrar", "text-left", "text-xl-center"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: false,
};

const dataCadastro: TableField = {
  key: "DataCadastro",
  label: "Data de Cadastro",
  tdClass: ["align-middle", "naoQuebrar", "text-left", "text-xl-center"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: true,
  formatter: defaultDateFormatter,
};
const dataCadastroSemSort: TableField = {
  ...dataCadastro,
  sortable: false,
};
const usuarioCadastro: TableField = {
  key: "UsuarioCadastro",
  label: "Usuário",
  tdClass: ["align-middle", "naoQuebrar", "text-left", "text-xl-center"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: true,
};
const titulo: TableField = {
  key: "Titulo",
  label: "Título",
  tdClass: ["align-middle", "quebrarPorPalavra", "text-left", "text-xl-center"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: true,
};
const tituloSemSort: TableField = {
  ...titulo,
  sortable: false,
};
const tipoAviso: TableField = {
  key: "TipoAviso",
  label: "Tipo de Aviso",
  tdClass: ["align-middle", "naoQuebrar", "text-left", "text-xl-center"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: false,
  formatter: (value: { Descricao?: string; Nome?: string }): string =>
    value?.Descricao ?? value?.Nome ?? "N\u00E3o informado",
};
const actions: TableField = {
  key: "actions",
  label: "Ações",
  tdClass: ["align-middle", "col-actions", "text-left", "text-xl-center"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: false,
};
const icone: TableField = {
  key: "icon",
  label: "",
  tdClass: ["align-middle", "text-right", "max3rem"],
  thClass: "text-center",
  sortable: false,
};

export const fieldsConsultaAvisos: TableField[] = [
  idAviso,
  dataCadastro,
  usuarioCadastro,
  titulo,
  tipoAviso,
  actions,
];

export const fieldsMuralAvisos: TableField[] = [
  icone,
  dataCadastroSemSort,
  tituloSemSort,
];
